if (!customElements.get("ac-product-card")) {
  class AcProductCard extends HTMLElement {
    constructor() {
      super();
      this._handleCardClick = this._handleCardClick.bind(this);
    }
    connectedCallback() {
      this.addEventListener("click", this._handleCardClick);
    }
    _handleCardClick(event) {
      const clickedInsideButtonOrLink = event.target.closest("button, a");
      if (!clickedInsideButtonOrLink) {
        this.querySelector("a").click();
      }
    }
  }
  customElements.define("ac-product-card", AcProductCard);
}
